import { COMPATIBILITY_STATUS_NON_COMPATIBLE } from 'constant'

export const checkIsCompatible = compatibility =>
  compatibility !== COMPATIBILITY_STATUS_NON_COMPATIBLE
